module.exports = __webpack_public_path__ + "img/no-personality-assessment.b02f4284.jpg";